import { Component } from '@angular/core';

@Component({
  selector: 'app-student-attendance-link',
  templateUrl: './student-attendance-link.component.html',
  styleUrls: ['./student-attendance-link.component.scss']
})
export class StudentAttendanceLinkComponent {

}
